module.exports = __webpack_public_path__ + "img/third-title.aabb305d.png";